import React from "react";
import { Box, Tooltip, IconButton } from "@mui/material";
import { Wifi, WifiOff, WifiFind } from "@mui/icons-material";
import { useSignalR } from "../../../../contexts/SignalRContext";

interface SignalRIndicatorProps {
  className?: string;
}

export const SignalRIndicator: React.FC<SignalRIndicatorProps> = ({
  className,
}) => {
  const { isConnected, isConnecting } = useSignalR();

  const getStatusInfo = () => {
    if (isConnected) {
      return {
        icon: <Wifi />,
        color: "#4CAF50", // Green
        tooltip: "SignalR Connected",
        status: "connected",
      };
    } else if (isConnecting) {
      return {
        icon: <WifiFind />,
        color: "#FF9800", // Orange/Yellow
        tooltip: "SignalR Reconnecting...",
        status: "connecting",
      };
    } else {
      return {
        icon: <WifiOff />,
        color: "#F44336", // Red
        tooltip: "SignalR Disconnected",
        status: "disconnected",
      };
    }
  };

  const statusInfo = getStatusInfo();

  return (
    <Box className={className}>
      <Tooltip title={statusInfo.tooltip} placement="bottom">
        <IconButton
          size="small"
          sx={{
            color: statusInfo.color,
            padding: 0.5,
            "&:hover": {
              backgroundColor: "rgba(0, 0, 0, 0.04)",
            },
          }}
        >
          {statusInfo.icon}
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default SignalRIndicator;
